import Vue from 'vue'
import Router from 'vue-router'
const Index = (resolve) => require(["@/views/index"], resolve);
const Result = (resolve) => require(["@/views/exam/result"], resolve);
const Exam = (resolve) => require(["@/views/exam/index"], resolve);
const Exersize = (resolve) => require(["@/views/exam/exersize"], resolve);

const Course = (resolve) => require(["@/views/course"], resolve);
const userCenter = (resolve) => require(["@/views/userCenter/index"], resolve);
const chooseCourse = (resolve) => require(["@/views/userCenter/chooseCourse"], resolve);
const learnCenter = (resolve) => require(["@/views/userCenter/learnCenter"], resolve);
const myorder = (resolve) => require(["@/views/userCenter/myorder"], resolve);
const onlineExam = (resolve) => require(["@/views/userCenter/onlineExame"], resolve);
const Record = (resolve) => require(["@/views/userCenter/record"], resolve);
const Pay = (resolve) => require(["@/views/userCenter/pay"], resolve);
const playPage = (resolve) => require(["@/views/playPage"], resolve);
const invoice = (resolve) => require(["@/views/invoice"], resolve);
const userInfo = (resolve) => require(["@/views/userCenter/userInfo"], resolve);
const print = (resolve) => require(["@/views/userCenter/print"], resolve);

Vue.use(Router)
let originPush= Router.prototype.push;
let originReplace= Router.prototype.replace;
//重写push/replace
//第一个参数：告诉原来的push方法，往哪里跳转（传递哪些参数）
//第二个参数：成功的回调
//第三个参数：失败的回调
//call/apply区别
//相同点：都可以调用函数一次，都可以篡改函数的上下文(this）一次‘
//不同点：call/apply传递参数：call传递参数用逗号隔开，apply方法执行，传递数组
Router.prototype.push=function(location,resolve,reject){
  if(resolve&&reject){
    originPush.call(this,location,resolve,reject);
  }else{
    originPush.call(this,location,()=>{},()=>{});
  }
}
Router.prototype.replace=function(location,resolve,reject){
  if(resolve&&reject){
    originReplace.call(this,location,resolve,reject);
  }else{
    originReplace.call(this,location,()=>{},()=>{});
  }
}
export default new Router({
  mode:'hash',
  routes: [
    {
      path: "/", // 登陆
      name: "index",
      component: Index,
      meta: {
        title: "首页",
      },
    },
    {
      path: "/result",
      name: "result",
      component: Result,
      meta: {
        title: "考试结果",
      },
    },
    {
      path: "/exersize",
      name: "exersize",
      component: Exersize,
      meta: {
        title: "练习",
      },
    },
    {
      path: "/exam",
      name: "exam",
      component: Exam,
      meta: {
        title: "考试",
      },
    },
    {
      path: "/print",
      name: "print",
      component: print,
      meta: {
        title: "打印证书",
      },
    },
    {
      path: "/course",
      name: "course",
      component: Course,
      meta: {
        title: "课程详情",
      },
    },
    {
      path: "/invoice",
      name: "invoice",
      component: invoice,
      meta: {
        title: "发票",
      },
    },
    {
      path: "/playPage",
      name: "playPage",
      component: playPage,
      meta: {
        title: "视频播放",
      },
    },
    {
      path: "/userCenter",
      name: "userCenter",
      component: userCenter,
      redirect: '/chooseCourse',
      children:[
        {
          path: "/chooseCourse",
          name: "chooseCourse",
          component: chooseCourse,
          meta: {
            title: "选择课程",
          },
        },
        {
          path: "/learnCenter",
          name: "learnCenter",
          component: learnCenter,
          meta: {
            title: "学习中心",
          },
        },
        {
          path: "/myorder",
          name: "myorder",
          component: myorder,
          meta: {
            title: "我的订单",
          },
        },
        {
          path: "/userInfo",
          name: "userInfo",
          component: userInfo,
          meta: {
            title: "信息维护",
          },
        },
        {
          path: "/onlineExam",
          name: "onlineExam",
          component: onlineExam,
          meta: {
            title: "参加在线考试",
          },
        },
        {
          path: "/Pay",
          name: "Pay",
          component: Pay,
          meta: {
            title: "缴纳学费",
          },
        },
        {
          path: "/Record",
          name: "Record",
          component: Record,
          meta: {
            title: "通过记录",
          },
        },


      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js